module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/medal-02-6d8e807e6efc0bd6a8ff6bcabd7b2d13.png";